import { render, staticRenderFns } from "./DatenView.vue?vue&type=template&id=d3a37cd0"
import script from "./DatenView.vue?vue&type=script&lang=js"
export * from "./DatenView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports